import { render } from "./NaacCertificateView.vue?vue&type=template&id=c33862f0"
import script from "./NaacCertificateView.vue?vue&type=script&lang=js"
export * from "./NaacCertificateView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__